import { Tab, Tabs, Typography } from '@material-ui/core';
import { CriApiResponse, EmissaoStatus, GrupoAcesso } from 'common/genericTypes';
import Chip from 'components/chip';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import SuspensaoHistorico, { SuspensaoHistoricoKind } from 'components/suspensaoHistorico';
import { LgSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RootState } from 'store';
import { DetalhesCaracteristicas } from './caracteristicas';
import { DetalhesCriteriosRemuneracao } from './criteriosRemuneracao';
import { DetalhesDocumentos } from './documentos';
import { DetalhesEventosFinanceiros } from 'common/detalhes/eventosFinanceiros';
import { initialCri } from './initialCri';
import Liquidacoes from './liquidacoes';
import Historico from './historico';
import { DetalhesAditamento } from '../../instrumentos/detalhes/aditamentos';

type ComponentParams = { criId: string };
type ComponentState = { initialTab?: number };

const mapStateToProps = (state: RootState) => ({
  isUsuarioControlesInternos: state.auth.usuario.grupoAcesso === GrupoAcesso.ControlesInternos,
  isUsuarioOperacoes: state.auth.usuario.grupoAcesso === GrupoAcesso.Operacoes,
  criApi: state.criApi,
});

type Props = ReturnType<typeof mapStateToProps> & RouteComponentProps<ComponentParams, {}, ComponentState>;

const DetalhesCri: React.FC<Props> = (props) => {
  const {
    isUsuarioControlesInternos,
    isUsuarioOperacoes,
    criApi: { getCriDetalhes: getCriDetalhesApi },
  } = props;
  const { criId } = props.match.params;

  const [tabValue, setTabValue] = useState<number>(props.location.state?.initialTab ?? 0);
  const [criDetalhes, setCriDetalhes] = useState<CriApiResponse>(initialCri);
  const [loadedDetalhes, setLoadedDetalhes] = useState<Boolean>(false);

  const dispatch = useDispatch();

  const getCriDetalhes = useCallback(async () => {
    try {
      const result = await getCriDetalhesApi(dispatch, criId, true);
      if (result) setCriDetalhes(result);
      setLoadedDetalhes(true);
    } catch (error) {}
  }, [dispatch, getCriDetalhesApi, criId]);

  useEffect(() => {
    getCriDetalhes();
  }, [getCriDetalhes]);

  return (
    <div style={{ marginRight: 40 }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="h1">
          {'CRI-'}
          {criDetalhes.codigo ?? criDetalhes.ticket}
        </Typography>
        {criDetalhes.suspenso && (
          <Chip
            size="medium"
            label="SUSPENSO"
            color="error"
            style={{
              margin: 20,
            }}
          />
        )}
        {criDetalhes.hasPagamentosInadimplentes && <Chip size="small" label="INADIMPLENTE" color="error" />}
      </div>
      <LgSpace />
      <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
          <Tab label="Características da Emissão" value={0} />
          <Tab label="Critérios de Remuneração" value={1} />
          <Tab label="Eventos Financeiros" value={2} />
          <Tab label="Documentos" value={3} />
          <Tab label="Aditamentos" value={7} />
          <Tab label="Suspensões" value={4} />
          <Tab label="Histórico" value={5} />
          {(isUsuarioControlesInternos || isUsuarioOperacoes) &&
            criDetalhes &&
            [EmissaoStatus.AguardandoLiquidacao, EmissaoStatus.Emitido, EmissaoStatus.ParcialmenteEmitido].includes(
              criDetalhes.statusEmissao
            ) && <Tab label="Liquidações" value={6} />}
        </Tabs>
      </HorizontalAppBar>
      {tabValue === 0 && <DetalhesCaracteristicas caracteristicas={criDetalhes} />}
      {tabValue === 1 && <DetalhesCriteriosRemuneracao criteriosRemuneracao={criDetalhes} />}
      {tabValue === 2 && <DetalhesEventosFinanceiros eventosFinanceiros={criDetalhes} />}
      {tabValue === 3 && <DetalhesDocumentos documentos={criDetalhes} />}
      {tabValue === 4 && (
        <SuspensaoHistorico
          kind={SuspensaoHistoricoKind.InstrumentoFinanceiro}
          registroHistoricos={criDetalhes.registro.registroHistoricos}
        />
      )}
      {tabValue === 5 && <Historico criDetalhes={criDetalhes} />}
      {tabValue === 6 && loadedDetalhes && (
        <Liquidacoes
          onConfirmarLiquidacaoSuccess={getCriDetalhes}
          liquidacaoDireta={criDetalhes.criteriosRemuneracao.liquidacaoDireta}
          aguardandoLiquidacao={criDetalhes.statusEmissao === EmissaoStatus.AguardandoLiquidacao}
          precoUnitarioLiquidacao={criDetalhes.criteriosRemuneracao.precoUnitarioLiquidacao}
          criId={criId}
          instrumentoFinanceiroGuid={criDetalhes.instrumentoFinanceiroGuid}
        />
      )}
      {tabValue === 7 && <DetalhesAditamento documentos={criDetalhes.instrumentoFinanceiroGuid} />}
    </div>
  );
};

export default connect(mapStateToProps)(withRouter(DetalhesCri));
